/**
 * HashMedora Game Configuration
 * Static data for all 5 lottery games
 */

export const GAMES = {
  strike: {
    id: 'strike',
    name: 'The Hash-Strike',
    shortName: 'Strike',
    tagline: 'Are you ready to hit the target?',
    subTagline: 'SECURE. FAIR. REWARDING.',
    tier: 'Entry Level',
    tierNumber: 1,
    numberRange: { min: 0, max: 9 },
    entryFee: 1,
    currency: 'USD',
    maxPrize: 4,
    directWinProbability: 0.1,
    neighborWinProbability: 0.2,
    totalWinProbability: 0.3,
    neighborCount: 2,
    neighborPrize: 1,
    directPrize: 4,
    description:
      'Your "volume" game. Designed for high frequency and quick engagement. With a 30% win rate, it builds immediate trust.',
    bestFor: 'New users and those who enjoy consistent, small wins to build their balance.',
    icon: '/images/icon-strike.png',
    textImage: '/images/text-strike.png',
    color: 'gold',
    maxNumbersPerTicket: 3,
    instantPayout: true,
  },
  vault: {
    id: 'vault',
    name: 'The Hash-Vault',
    shortName: 'Vault',
    tagline: 'Are you ready to unlock the Vault?',
    subTagline: 'PREMIUM TIER. BALANCED RISK.',
    tier: 'Intermediate',
    tierNumber: 2,
    numberRange: { min: 0, max: 99 },
    entryFee: 1,
    currency: 'USD',
    maxPrize: 30,
    directWinProbability: 0.01,
    neighborWinProbability: 0.3,
    totalWinProbability: 0.31,
    neighborCount: 30,
    neighborPrize: 1,
    directPrize: 30,
    description:
      'Paradoxically, this has a slightly higher total win probability because of the expanded 30-neighbor net. It feels "safer" despite the higher jackpot.',
    bestFor: 'Strategic players who want a significant payout but refuse to play games with narrow winning margins.',
    icon: '/images/icon-vault.png',
    textImage: '/images/text-vault.png',
    color: 'blue',
    maxNumbersPerTicket: 5,
    instantPayout: true,
  },
  quantum: {
    id: 'quantum',
    name: 'The Hash-Quantum',
    shortName: 'Quantum',
    tagline: 'Step beyond the ordinary. Beyond the Vault.',
    subTagline: 'ULTIMATE TIER. STRATEGIC ROI.',
    tier: 'Professional',
    tierNumber: 3,
    numberRange: { min: 0, max: 999 },
    entryFee: 1,
    currency: 'USD',
    maxPrize: 300,
    directWinProbability: 0.001,
    neighborWinProbability: 0.3,
    totalWinProbability: 0.301,
    neighborCount: 300,
    neighborPrize: 1,
    directPrize: 300,
    description:
      'The "Digital Entrepreneur" favorite. It provides a massive capital boost (1 USD to 300 USD) while maintaining the 30% community "safety net" through its 300-neighbor network.',
    bestFor: 'Serious players looking to leverage small amounts into meaningful project capital.',
    icon: '/images/icon-quantum.png',
    textImage: '/images/text-quantum.png',
    color: 'blue',
    maxNumbersPerTicket: 10,
    instantPayout: true,
  },
  apex: {
    id: 'apex',
    name: 'The Hash-Apex',
    shortName: 'Apex',
    tagline: 'Chase the pinnacle of multipliers. Prestige defined.',
    subTagline: 'SUMMIT TIER. MAXIMUM PAYOUT.',
    tier: 'Elite Tier',
    tierNumber: 4,
    numberRange: { min: 0, max: 9999 },
    entryFee: 1,
    currency: 'USD',
    maxPrize: 3000,
    directWinProbability: 0.0001,
    neighborWinProbability: 0.3,
    totalWinProbability: 0.3001,
    neighborCount: 3000,
    neighborPrize: 1,
    directPrize: 3000,
    description:
      'The pinnacle of daily play. It offers a "moonshot" payout of 3,000 USDT. The real power here is the Instant Real-Time Payout, which proves the platform\'s blockchain efficiency at high stakes.',
    bestFor: 'High-stakes enthusiasts chasing life-changing multipliers.',
    icon: '/images/icon-apex.png',
    textImage: '/images/text-apex.png',
    color: 'gold',
    maxNumbersPerTicket: 25,
    instantPayout: true,
  },
  apex2: {
    id: 'apex2',
    name: 'The Hash-Apex2',
    shortName: 'Apex2',
    tagline: 'Chase the pinnacle of multipliers. Prestige defined.',
    subTagline: 'SUMMIT TIER. MAXIMUM PAYOUT.',
    tier: 'Elite Tier',
    tierNumber: 4,
    numberRange: { min: 0, max: 9999 },
    entryFee: 100,
    currency: 'USD',
    maxPrize: 200000,
    directWinProbability: 0.0001,
    neighborWinProbability: 0.3,
    totalWinProbability: 0.3001,
    neighborCount: 2,
    neighbor2Count: 3600,
    neighborPrize: 20000,
    neighbor2Prize: 100,
    directPrize: 200000,
    description:
      'The pinnacle of daily play. It offers a "moonshot" payout of 3,000 USDT. The real power here is the Instant Real-Time Payout, which proves the platform\'s blockchain efficiency at high stakes.',
    bestFor: 'High-stakes enthusiasts chasing life-changing multipliers.',
    icon: '/images/icon-apex.png',
    textImage: '/images/text-apex2.png',
    color: 'gold',
    maxNumbersPerTicket: 25,
    instantPayout: true,
  },
  summit: {
    id: 'summit',
    name: 'The Summit Draw',
    shortName: 'Summit',
    tagline: 'The flagship bumper event. Mass-winning moments.',
    subTagline: 'COMMUNITY EVENT. UP TO 10,000X.',
    tier: 'Flagship Event',
    tierNumber: 5,
    numberRange: { min: 1, max: 100000 },
    entryFee: 5,
    currency: 'USD',
    maxPrize: 50000,
    directWinProbability: 0.00001,
    neighborWinProbability: 0.205,
    totalWinProbability: 0.205,
    neighborCount: 20503,
    neighborPrize: 1,
    directPrize: 50000,
    grandPrizePool: 300000,
    tiers: [
      {
        name: 'Apex Mastery',
        prize: 50000,
        neighborCount: 5000,
        neighborPrize: 20,
        totalPool: 150000,
      },
      {
        name: 'Vault Access',
        prize: 25000,
        neighborCount: 7500,
        neighborPrize: 10,
        totalPool: 100000,
      },
      {
        name: 'Strike Foundation',
        prize: 10000,
        neighborCount: 8000,
        neighborPrize: 5,
        totalPool: 50000,
      },
    ],
    description:
      'A community-wide event rather than a standard game. With 20,503 guaranteed winners, it is the platform\'s strongest marketing tool. It creates "mass-winning" moments that generate social proof.',
    bestFor: 'Everyone in the community. It is the must-play event of the season.',
    icon: '/images/icon-summit.png',
    textImage: '/images/text-summit.png',
    color: 'gold',
    maxNumbersPerTicket: 3,
    isSpecialEvent: true,
    playDisabled: true,
  },
};

export const GAME_IDS = ['strike', 'vault', 'quantum', 'apex', 'apex2', 'summit'];

/** First game in the selector; vault credit balance is shown above this tile on the Games page. */
export const STRIKE_GAME_ID = 'strike';

export function getGameConfig(gameId) {
  return GAMES[gameId] || null;
}

/** False when the game cannot accept bets yet (e.g. Summit flagship event). */
export function isGamePlayEnabled(gameId) {
  const game = getGameConfig(gameId);
  return Boolean(game && !game.playDisabled);
}

export function getAllGames() {
  return GAME_IDS.map((id) => GAMES[id]);
}

export function getDefaultGameId() {
  try {
    const saved = localStorage.getItem('hashmedora_last_game');
    if (saved && GAMES[saved] && isGamePlayEnabled(saved)) return saved;
  } catch {
    // ignore
  }
  return 'strike';
}

export function saveLastGameId(gameId) {
  try {
    localStorage.setItem('hashmedora_last_game', gameId);
  } catch {
    // ignore
  }
}

export const COMPARISON_TABLE = [
  {
    game: 'Strike',
    entryFee: '1 USD',
    maxPrize: '4 USD',
    winChance: '30%',
    appeal: 'High Frequency',
  },
  {
    game: 'Vault',
    entryFee: '1 USD',
    maxPrize: '30 USD',
    winChance: '31%',
    appeal: 'Balanced Risk',
  },
  {
    game: 'Quantum',
    entryFee: '1 USD',
    maxPrize: '300 USD',
    winChance: '30.1%',
    appeal: 'Strategic ROI',
  },
  {
    game: 'Apex',
    entryFee: '1 USD',
    maxPrize: '3,000 USD',
    winChance: '30.01%',
    appeal: 'Maximum Payout',
  },
  {
    game: 'Apex2',
    entryFee: '100 USD',
    maxPrize: '200,000 USD',
    winChance: '30.01%',
    appeal: 'Maximum Payout',
  },
  {
    game: 'Summit',
    entryFee: '5 USD',
    maxPrize: '50,000 USD',
    winChance: '20.5%',
    appeal: 'Community Event',
  },
];

export default GAMES;
